import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import ReinviteOrganisationView from './ReinviteOrganisationView';
import SubcontractorAddPanel from './subcontractorAddPanel';
import organisationService from '../../../../services/organisation/OrganisationService';
import {captureError} from '../../../../utils/log';

function ReinviteOrganisationContainer({organisationId}) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [organisation, setOrganisation] = useState(null);

  useEffect(() => {
    organisationService.get(organisationId)
      .then(response => setOrganisation(response))
      .catch(error => captureError('Error while getting organisation details', error));
  }, []);

  return (
    <>
      <ReinviteOrganisationView onReinvite={() => setIsPanelOpen(true)}/>
      <SubcontractorAddPanel
        isOpen={isPanelOpen}
        onClose={() => setIsPanelOpen(false)}
        reinvitedOrganisation={organisation}
      />
    </>
  );
}

ReinviteOrganisationContainer.propTypes = {
  organisationId: PropTypes.number.isRequired
};

export default ReinviteOrganisationContainer;
